import * as tslib_1 from "tslib";
import { Actions, Effect } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { withPredicateFrom } from '../../core/helpers/rx-pipes';
import { OrderService } from '../services/orders.service';
import * as meta from '../actions/meta';
import * as order from '../actions/orders';
import * as fromOrders from '../reducers';
import * as fromAuth from '../../auth/reducers';
var OrderEffects = /** @class */ (function () {
    function OrderEffects(actions$, store, orderSvc) {
        var _this = this;
        this.actions$ = actions$;
        this.store = store;
        this.orderSvc = orderSvc;
        this.initCompleted$ = this.actions$.ofType(meta.INIT_SUCCESS, meta.INIT_SKIPPED)
            .pipe(map(function (action) { return new order.Load(); }));
        this.loadOrders$ = this.actions$.ofType(order.LOAD)
            .pipe(withLatestFrom(this.store.pipe(select(fromOrders.getAppliedFacets)), this.store.pipe(select(fromAuth.getCustomerId)), function (action, applied, customerId) { return ({ applied: applied, customerId: customerId }); }), switchMap(function (data) {
            return _this.orderSvc.getOrders(data.customerId, data.applied)
                .pipe(map(function (lines) { return new order.LoadSuccess(lines); }), catchError(function (e) { return of(new order.LoadFailed(e)); }));
        }));
        this.expandOrderlines$ = this.actions$.ofType(order.EXPAND)
            .pipe(withPredicateFrom(this.store.pipe(select(fromOrders.canExpand))), withLatestFrom(this.store.pipe(select(fromOrders.getCombinedExpandState)), this.store.pipe(select(fromOrders.getNextPageNumber)), this.store.pipe(select(fromAuth.getCustomerId)), function (action, state, nextPage, customerId) { return ({ state: state, nextPage: nextPage, customerId: customerId }); }), switchMap(function (data) {
            return _this.orderSvc.getOrders(data.customerId, data.state.facets, data.nextPage)
                .pipe(map(function (lines) { return new order.ExpandSuccess(lines); }), catchError(function (e) { return of(new order.ExpandFailed(e)); }));
        }));
    }
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], OrderEffects.prototype, "initCompleted$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], OrderEffects.prototype, "loadOrders$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], OrderEffects.prototype, "expandOrderlines$", void 0);
    return OrderEffects;
}());
export { OrderEffects };
